export const animatePlanCards = () => {
  const toggleContainer = document.querySelector('.toggle');
  if (!toggleContainer) return;
  const urlSplit = document.URL.split('#');
  const baseUrl = urlSplit[0];
  const anchorLink = urlSplit[1];
  const items = document.querySelectorAll('.toggle > a');
  const container = document.querySelector('.toggle .selected-item');
  const elementsPriceCards = document.querySelectorAll('.swiper-container-overview-cards .swiper-slide');
  const currentURL = new URL(document.URL);
  const preSelect = currentURL.searchParams.get('select-toggle');

  const animationChangePlanCard = () => {
    elementsPriceCards.forEach(element => {
      element.style.transform = 'translateY(50px)';
      element.style.opacity = '0';

      setTimeout(() => {
        element.style.transform = '';
        element.style.opacity = '';
      }, 300);
    });
  };
  // variables to know where the background black on toggle section should be
  let selectedItemId = 0;
  let translateElement = 0;

  if (preSelect) {
    // anchors manually
    if (window.matchMedia('(max-width: 767px)').matches && window.location.hash === '#mobile-table-header-anchor') {
      const anchors = document.querySelectorAll('.mobile-table-header-anchor');
      setTimeout(() => {
        if (preSelect === 'solo') {
          anchors[0].scrollIntoView();
        } else if (preSelect === 'team') {
          anchors[1].scrollIntoView();
        } else if (preSelect === 'creation') {
          anchors[2].scrollIntoView();
        }
      }, 1000);
    } else if (window.location.hash === '#desktop-table-header-anchor') {
      const anchors = document.querySelectorAll('.desktop-table-header-anchor');
      setTimeout(() => {
        if (preSelect === 'solo') {
          anchors[0].scrollIntoView();
        } else if (preSelect === 'team') {
          anchors[1].scrollIntoView();
        } else if (preSelect === 'creation') {
          anchors[2].scrollIntoView();
        }
      }, 1000);
    }
    // position correctly the background black on toggle section if you preselect a plan overview in the url
    let selectedElement = document.querySelector(`.toggle a[data-params-slug="${preSelect}"]`);
    if (!selectedElement) {
      selectedElement = document.querySelector('.toggle a[data-params-slug="solo"]');
    }
    items.forEach((item, index) => {
      if (item === selectedElement) {
        selectedItemId = index;
      }
    });
    for (let i = 0; i < selectedItemId; i++) {
      translateElement += items[i].getBoundingClientRect().width;
    }
    container.style.transform = `translateX(${translateElement}px)`;
    container.style.width = `${selectedElement.getBoundingClientRect().width + 1}px`;
  } else {
    container.style.width = `${items[0].getBoundingClientRect().width + 1}px`;
  }
  // add transition to the background black on toggle section
  container.style.transition = 'all 0.3s cubic-bezier(1, -0.02, 0, 1.2)';

  // to put a correct translate to container, we make the sum of each item's width before the selected item
  // we also change the width of container with the selected item
  items.forEach((item, index) => {
    item.addEventListener('click', (event) => {
      // avoid to click on toggle while animation is running
      toggleContainer.style.pointerEvents = 'none';
      setTimeout(() => {
        toggleContainer.style.pointerEvents = '';
      }, 300);
      toggleContainer.style.overflow = 'hidden';

      if (selectedItemId < index) {
        for (let i = selectedItemId; i < index; i++) {
          translateElement += items[i].getBoundingClientRect().width;
        }
        container.style.width = `${event.currentTarget.getBoundingClientRect().width + 1}px`;
        container.style.transform = `translateX(${translateElement}px)`;
        selectedItemId = index;
        animationChangePlanCard();
      } else if (selectedItemId > index) {
        for (let i = selectedItemId; i > index; i--) {
          translateElement -= items[i - 1].getBoundingClientRect().width;
        }
        container.style.width = `${event.currentTarget.getBoundingClientRect().width + 1}px`;
        container.style.transform = `translateX(${translateElement}px)`;
        selectedItemId = index;
        animationChangePlanCard();
      }
    });
  });

  // on resize we change the width and translate of container related to the selected item
  let timer = null;
  window.addEventListener('resize', () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (container.offsetWidth === items[selectedItemId].offsetWidth) return;
      container.style.width = `${items[selectedItemId].offsetWidth + 1}px`;
      translateElement = 0;
      container.style.transition = '';
      for (let i = 0; i < selectedItemId; i++) {
        translateElement += items[i].getBoundingClientRect().width;
      }
      container.style.transform = `translateX(${translateElement}px)`;
      container.style.transition = 'all 0.3s cubic-bezier(1, -0.02, 0, 1.2)';
    }, 100);
  });

  if (!baseUrl || !baseUrl.endsWith('/pricing')) { return; }

  if (anchorLink && anchorLink.match(/creators-*/)) {
    window.location = baseUrl + '?select-toggle=creation';
    return;
  };
};
